<div class="account-balance-green" style="display: flex; align-items: center; font-weight: bold; padding-left: 13px;">
  <span style="font-size: 18px; margin-right: 7px;">Outstanding :  {{balanceDue}} </span>
  <span style="font-size: 18px; margin-right: 15px;">Billed {{totalBilled}}</span>
</div>
